import blog1 from '../assets/png/blog1.png';
import blog2 from '../assets/png/blog2.png';
import blog3 from '../assets/png/blog3.png';

export const blogData = [
    {
        id: 1,
        title: 'React Native For Web: Merging the worlds of mobile and web',
        description: 'A Brief about * React Native For Web * ',
        date: 'Noc 10, 2020',
        image: blog1,
        url: 'https://sirshikher.medium.com/react-native-for-web-merging-the-worlds-of-mobile-and-web-d214123070dd'
    },
    {
        id: 2,
        title: 'Deploying Website with Gatsby',
        description: 'Deploying Website with Gatsby (using ReactJS 🙀),Contentful 🙌 and Netlify in 8 Simple Steps',
        date: 'Sep 17, 2019',
        image: blog2,
        url: 'https://sirshikher.medium.com/deploying-website-with-gatsby-using-reactjs-contentful-and-netlify-in-8-simple-f16605116b9e'
    },
    {
        id: 3,
        title: 'Creating MicroFrontend paradigms',
        description: 'Creating MicroFrontend paradigms using Bit Tool 🎩 PS:Why only backend have all the fun of MicroServices',
        date: 'Dec 22, 2019',
        image: blog3,
        url: 'https://sirshikher.medium.com/creating-microfrontend-application-using-bit-tool-why-only-backend-have-all-the-fun-of-16b7e591b7d8'
    },
    
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/